import { Model } from '@vuex-orm/core'

export default class Boss extends Model {
    static entity = 'bosses'

    static primaryKey = 'name'

    static fields() {
        return {
            name: this.attr(''),
            area_id: this.attr(null),
            completed: this.attr(false)
        }
    }
}